import { collapsibleSection } from './collapsibleSection';

export const venuePage = function() {
	const collapsedSection = document.querySelector('.venue-details__text');

	if (collapsedSection) {
		collapsibleSection(collapsedSection);
	}
};
